import { useLayout } from "library/hooks/useLayout";
import { useEffect, useReducer } from "react";
import { usePageTracking } from "react-event-tracker";
import { Layout } from "../Layout/Layout";
import { DirectDebitCancel } from "./DirectDebitCancel";
import { DirectDebitCancelSuccess } from "./DirectDebitCancelSuccess";
import { DirectDebitError } from "./DirectDebitError";
import { DirectDebitFAQ } from "./DirectDebitFAQ";
import { DirectDebitForm } from "./DirectDebitForm";
import { DirectDebitLanding } from "./DirectDebitLanding";
import {
  directDebitReducer,
  initialDirectDebitState,
  PAGES,
} from "./directDebitReducer";
import { DirectDebitSuccess } from "./DirectDebitSuccess";

const pageInfo = {
  [PAGES.LANDING]: {
    heading: "Direct debit request",
    screenComponent: DirectDebitLanding,
  },
  [PAGES.FORM]: {
    heading: "Set up direct debit request",
    screenComponent: DirectDebitForm,
  },
  [PAGES.SUCCESS]: {
    heading: "Direct debit set up successfully",
    headingIcon: "success",
    screenComponent: DirectDebitSuccess,
  },
  [PAGES.ERROR]: {
    heading: "Direct debit request",
    screenComponent: DirectDebitError,
  },
  [PAGES.CANCEL]: {
    heading: "Confirm direct debit cancellation",
    screenComponent: DirectDebitCancel,
  },
  [PAGES.CANCEL_SUCCESS]: {
    heading: "Direct debit",
    screenComponent: DirectDebitCancelSuccess,
  },
};

function DirectDebitScreen({
  screenComponent: ScreenComponent,
  state,
  dispatch,
}) {
  const { scrollToTop } = useLayout();

  useEffect(() => {
    scrollToTop();
  }, [scrollToTop, ScreenComponent]);

  return <ScreenComponent state={state} dispatch={dispatch} />;
}

export const DirectDebit = () => {
  const [state, dispatch] = useReducer(
    directDebitReducer,
    initialDirectDebitState,
  );
  const { page } = state;
  const {
    heading: pageHeading,
    headingIcon: pageHeadingIcon,
    screenComponent,
  } = pageInfo[page];

  usePageTracking({
    page: {
      pageType: "information-page",
      siteSection: "accounts",
      siteSubSection: "payment",
      pageTitle: "direct-debit",
    },
    user: {
      authenticationStatus: "logged in",
    },
  });

  return (
    <Layout>
      <Layout.Header icon={pageHeadingIcon}>{pageHeading}</Layout.Header>
      <Layout.Main>
        <DirectDebitScreen
          screenComponent={screenComponent}
          state={state}
          dispatch={dispatch}
        />
      </Layout.Main>
      <Layout.Sidebar>
        <DirectDebitFAQ />
      </Layout.Sidebar>
    </Layout>
  );
};
